@for (action of actions; track action.icon) {
  <button
    mat-icon-button
    type="button"
    class="row-action"
    [matTooltip]="action.label"
    [matTooltipClass]="'app-tooltip'"
    [attr.aria-label]="action.label"
    (click)="onActionClick($event, action)">
    <mat-icon>{{ action.icon }}</mat-icon>
  </button>
}
